import React from "react";

import { useTranslation } from "react-i18next";

import CarouselDoubleRow from "./CarouselDoubleRow";
import CarouselSingleRow from "./CarouselSingleRow";

import type { JSX } from "react";

import type { CarouselRow } from "../../../constants/carouselRow";
import type { HorizontalImageFormat } from "../../../constants/ratio";

interface CarouselRowSelectorProps {
  ratio?: HorizontalImageFormat;
  selected?: CarouselRow;
  onClick: (row: CarouselRow) => void;
}

function CarouselRowSelector({
  ratio,
  selected = "single",
  onClick,
}: CarouselRowSelectorProps): JSX.Element {
  const { t } = useTranslation("editor-platform");

  const isSingleCarouselSelected = selected === "single";
  const isDoubleCarouselSelected = selected === "double";

  return (
    <div className="flex flex-col gap-[0.3125rem]">
      <span className="text-muted-foreground">{t("carouselType")}</span>
      <div className="flex overflow-x-auto">
        <CarouselSingleRow
          isSelected={isSingleCarouselSelected}
          onClick={onClick}
          ratio={ratio}
        />
        <CarouselDoubleRow
          isSelected={isDoubleCarouselSelected}
          onClick={onClick}
          ratio={ratio}
        />
      </div>
    </div>
  );
}

export default CarouselRowSelector;
